export enum TenantConfigTypes {
  InvoiceGenerator = 'invoiceGenerator',
  Otp = 'otp'
}
